const tabLabelToAriaRoleId = (label: string) => {
  return `${label.toLowerCase().replaceAll(' ', '-')}-panel`;
};

export { tabLabelToAriaRoleId };
